module.exports = __webpack_public_path__ + "media/images/front/icon_facebook-f7ed131c5cfe2c348432ee1e98184bed.png";